// src/pages/VerifyCodePage.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { IoHomeOutline } from "react-icons/io5";
import { useVerifyCodeMutation } from "../context/authApi";

export default function VerifyCodePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const phone = location.state?.phone; // +998... ko'rinishida

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [verifyCode, { isLoading }] = useVerifyCodeMutation();

  // Agar bevosita /verify ga kirsa, register-phone ga qaytaramiz
  useEffect(() => {
    if (!phone) {
      navigate("/register-phone");
    }
  }, [phone, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (code.trim().length !== 6) {
      setError("6 xonali tasdiqlash kodini kiriting. (Hozircha: 123456)");
      return;
    }

    try {
      await verifyCode({ phone, code }).unwrap();

      // muvaffaqiyatli tasdiqlansa, 3-bosqichga o'tamiz
      navigate("/complete-register", { state: { phone } });
    } catch (err) {
      console.error(err);
      setError(
        err?.data?.message || "Tasdiqlash kodini tekshirishda xatolik yuz berdi."
      );
    }
  };

  return (
    <div className="min-h-screen flex flex-col pt-12 pb-8 sm:pt-16 sm:pb-12 md:pt-20 md:pb-16 lg:pt-24 lg:pb-20 xl:pt-28 xl:pb-24">
      {/* Logo */}
      <div className="pt-8 flex justify-center">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white font-semibold text-lg">
            L
          </div>
          <span className="text-lg font-semibold text-gray-900">
            LiveQuiz.uz
          </span>
        </div>
      </div>

      {/* Card */}
      <div className="flex-1 flex items-start justify-center mt-4 px-4 pb-10">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg border border-gray-100 px-8 py-8 sm:px-10 sm:py-10">
          {/* Bosh sahifa */}
          <div className="flex justify-end mb-4 text-xs text-gray-500">
            <Link
              to="/"
              className="flex items-center gap-1 hover:text-gray-800"
            >
              <IoHomeOutline className="text-base" />
              Bosh sahifa
            </Link>
          </div>

          {/* Title */}
          <div className="text-center mb-6">
            <h1 className="text-[22px] sm:text-[24px] font-semibold text-gray-900">
              Telefon raqamini tasdiqlang
            </h1>
            <p className="mt-2 text-xs sm:text-[13px] text-gray-500">
              {phone} raqamiga yuborilgan 6 xonali kodni kiriting
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-800 mb-1.5">
                Tasdiqlash kodi *
              </label>
              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="123456"
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-center tracking-[0.3em] text-lg outline-none focus:bg-white focus:border-black focus:ring-1 focus:ring-black"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              />
            </div>

            {error && (
              <p className="text-[11px] text-red-500 leading-snug">{error}</p>
            )}

            <div className="pt-2">
              <button
                type="submit"
                disabled={isLoading}
                className="w-full rounded-lg bg-black text-white text-sm font-medium py-2.5 hover:bg-gray-900 transition disabled:opacity-70"
              >
                {isLoading ? "Tekshirilmoqda..." : "Tasdiqlash"}
              </button>
            </div>
          </form>

          {/* Kod kelmadimi? */}
          <div className="mt-4 text-center text-xs text-gray-500">
            Kod kelmadimi? Hozircha test rejimida kod har doim{" "}
            <span className="font-semibold">123456</span>.
          </div>
        </div>
      </div>

      <div className="pb-6 text-center text-[11px] text-gray-400">
        © {new Date().getFullYear()} LiveQuiz.uz. Barcha huquqlar himoyalangan.
      </div>
    </div>
  );
}
